import React from "react"
import Image from "gatsby-image"
import { Link } from "gatsby"
import styled from "styled-components"

const Who = ({ image, header, text,index }) => {
  var marginTop = 112
  if (index === 1) marginTop += 40
  if (index === 2) marginTop += 60
  
  
  return (
    <Wrapper>
      <div className="image">
        <Image fluid={image} alt={header}/>
      </div>
      
      <div className="info-text">
        <h3 style={{marginTop: marginTop }}>{header}</h3>
        <p>{text}</p>
        <Link to="#" className="btn btn-bordered learn">
          Learn More
        </Link>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.article`
    margin-top: 3rem;
    height: 547px;
    background: var(--clr-white);
    border-radius: 10px;
    color: var(--clr-primary-1);
    display: flex;
    gap: 80px;
    align-items: center;

    .image {
      width: 100%;
      margin-left: 95px;
      flex-basis: 35%;
    }
    .info-text {      
      flex-basis: 65%;
    }

    h3 { font-size: 2.25rem; }

    p {
      margin-top: 40px;
      font-size: 1rem;
      width: 90%;
    }

    .btn-bordered {
      margin-top: 40px;
      margin-bottom: 73px;
      background: var(--clr-white);
      :hover {
        background: var(--clr-primary-1);
      }
    }
`


export default Who
